import React, { useState, useEffect } from 'react'
import {Fade, Stack, Grid, Typography} from "@mui/material";
import {useTranslation} from 'react-i18next';
import Transition from '../../components/Transition/Transition';
import PageHeader from '../../components/PageHeader/PageHeader';
import AboutItem from '../../components/AboutItem/AboutItem';
function About() 
{
  const [read, setRead] = useState(false);
  const [bios, setBios] = useState([]);

  useEffect(() => {
    fetch('/data/bio.json')
      .then((response) => response.json())
      .then((jsonData) => setBios(jsonData))
      .catch((error) => console.error('Error loading JSON:', error));
  }, []);


  const changeRead = () =>
  {
    setRead(true);
  }

const { t: tGlobal } = useTranslation('global');
const { t: tBios } = useTranslation('bios');
  return (
    <Stack direction="row" sx={{justifyContent:"center", minHeight:"65.5vh", backgroundColor:"background.main"}}>
      <Fade in={true} timeout={2000}>
        <Stack direction="column" height="100%" width={{md:"90%", xs:"95%"}}>
          <PageHeader weight={tGlobal("NavBar.Starlight.length")}>{tGlobal("NavBar.Starlight.title")}</PageHeader>
          <Grid container direction={{lg:"row", md:"row", xs:"row"}} marginTop={{lg:"3vh", md:"2vh", xs:"1vh"}}>
        <Grid item lg={12} md={12} xs={12} marginBottom={{lg:"2.5vh", md: "1.5vh", xs:"0vh"}} >
            <Stack direction="row" justifyContent={{lg:"center", md:"center", xs:"center"}}>
              <Stack direciton="row" width={{lg:"35%", md:"75%", xs:"95%"}} justifyContent={{lg:"center", md:"center", xs:"center"}}>
              <img width="100%" alt="Starlight Opera" src={"/image/bios/starlightopera.webp"}/>
              </Stack>
            </Stack>
        </Grid>
        <Grid item lg={12} md={12} xs={12} marginTop={{lg:"0vh", md: "0vh", xs:"1.5vh"}} marginBottom={{lg:"3vh", md: "0vh", xs:"0vh"}} >
            <Stack direction="row" justifyContent={{lg:"center", md:"center", xs:"center"}}>
            <Stack direciton="row" width={{lg:"100%", md:"90%", xs:"90%"}} justifyContent={{lg:"center", md:"center", xs:"center"}} display={read?"none":"flex"}>
            <Typography variant="body1" fontSize={{lg:"20px", md:"20px", xs:"18px"}}>{tGlobal("Bios.intro-1")} <u onClick={()=> changeRead()}>{tGlobal("Bios.readmore")}</u> </Typography>
            </Stack>
            <Stack direciton="row" width={{lg:"100%", md:"90%", xs:"90%"}} justifyContent={{lg:"center", md:"center", xs:"center"}} display={read?"flex":"none"}>
            <Typography variant="body1" fontSize={{lg:"20px", md:"20px", xs:"18px"}}>{tGlobal("Bios.intro-1")}  </Typography>
            <Typography variant="body1" fontSize={{lg:"20px", md:"20px", xs:"18px"}}>{tGlobal("Bios.intro-2")}  </Typography>
            </Stack>
            </Stack>
        </Grid>
        <Grid item lg={12} md={12} xs={12} justifyContent="center" marginTop={{lg:"0vh", md: "0vh", xs:"1.5vh"}} marginBottom={{lg:"1vh", md: "0vh", xs:"0vh"}}  container>
          <PageHeader weight={tGlobal("NavBar.President.length")}>{tGlobal("NavBar.President.title")}</PageHeader>
          {
            bios.map((bio)=>
            {
              if(bio.catergory.includes("president"))
              {
                return (
                <AboutItem thumbnail={bio.thumbnail} name={bio.name} id={bio.id}/>
              )
              }
              
            })
          }
        </Grid>
        <Grid item lg={12} md={12} xs={12} justifyContent="center" marginTop={{lg:"0vh", md: "0vh", xs:"1h"}} marginBottom={{lg:"1vh", md: "0vh", xs:"0vh"}} container >

        <PageHeader weight={tGlobal("NavBar.BD.length")}>{tGlobal("NavBar.BD.title")}</PageHeader>
        {
            bios.map((bio)=>
            {
              if(bio.catergory.includes("BD") && !bio.catergory.includes("president") )
              {
                return (
                <AboutItem id={bio.id}/>
              )
              }
              
            })
          }
        </Grid>
        <Grid item lg={12} md={12} xs={12} justifyContent="center" marginTop={{lg:"0vh", md: "0vh", xs:"1vh"}} marginBottom={{lg:"1vh", md: "0vh", xs:"0vh"}}container>
        <PageHeader weight={tGlobal("NavBar.HA.length")}>{tGlobal("NavBar.HA.title")}</PageHeader>
        {
            bios.map((bio)=>
            {
              if(bio.catergory.includes("HA") && !bio.catergory.includes("president") )
              {
                return (
                <AboutItem id={bio.id}/>
              )
              }
              
            })
          }
        </Grid>
        <Grid item lg={12} md={12} xs={12} justifyContent="center" marginTop={{lg:"0vh", md: "0vh", xs:"1vh"}} marginBottom={{lg:"1vh", md: "0vh", xs:"0vh"}}container>
        <PageHeader weight={tGlobal("NavBar.AD.length")}>{tGlobal("NavBar.AD.title")}</PageHeader>
        {
            bios.map((bio)=>
            {
              if(bio.catergory.includes("AD") && !bio.catergory.includes("president") )
              {
                return (
                <AboutItem id={bio.id}/>
              )
              }
              
            })
          }
        </Grid>
        <Grid item lg={12} md={12} xs={12} justifyContent="center" marginTop={{lg:"0vh", md: "0vh", xs:"1vh"}} marginBottom={{lg:"1vh", md: "0vh", xs:"0vh"}} container>
        <PageHeader weight={tGlobal("NavBar.Instructor.length")}>{tGlobal("NavBar.Instructor.title")}</PageHeader>
        {
            bios.map((bio)=>
            {
              if(bio.catergory.includes("Instructor") && !bio.catergory.includes("president") )
              {
                return (
                <AboutItem id={bio.id}/>
              )
              }
              
            })
          }
        </Grid>
          </Grid>
        </Stack>
      </Fade>
      
    </Stack>
  )
}export default Transition(About);